import type { RouteHandle } from '~/routing/types';

function isMessageDescriptor(value: unknown): value is RouteHandle['title'] {
  return (
    typeof value === 'object' &&
    value !== null &&
    'id' in value &&
    typeof value.id === 'string'
  );
}

export function isRouteHandle(value: unknown): value is RouteHandle {
  return (
    typeof value === 'object' &&
    value !== null &&
    'title' in value &&
    isMessageDescriptor(value.title)
  );
}
